import gql from 'graphql-tag';

export default gql`
  query flightsPageTranslations {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        translations(language: enUS) {
          breadcrumb {
            ticketsStepTitle
            flightsStepTitle
            bundlesStepTitle
            travelersStepTitle
            seatsStepTitle
            bagsStepTitle
            hotelsStepTitle
            carsStepTitle
            paymentStepTitle
            cartOverrideStepTitle
          }
        }
      }
    }
  }
`;
